module.exports = __webpack_public_path__ + "img/icon-model-precise_color.db3b9fe8.svg";